{
  "name": "demo",
  "hostname": "demo.serveport.com",
  "development": false,
  "production": true,
  "applicationName": "ServePort",
  "sourceVersion": "51ecffabfac73e2a61ed9d99bb7cb674aa0abd64",
  "errors": {
    "numRetries": 3
  },
  "urls": {
    "apiRootCoManage": "https://@.demo.serveport.com/_api/comanage/",
    "apiRootLpms": "https://@.demo.serveport.com/_api/lpms/",
    "apiRootSquirrel": "https://@.demo.serveport.com/_api/squirrel/",
    "apiRootRms": "https://@.demo.serveport.com/_api/rms/"
  },
  "stripe": {
    "key": "pk_test_sXNkfHf4SoQCOwMv6G26jnOd00AaAlGrWM"
  },
  "auth0": {
    "authorityRoot": "safarilaw-demo.auth0.com",
    "clientId": "OiLUAWTLHOxQwhWDA9nFpFZCljiYzyAE",
    "useLocalStorageCache": false
  },
  "auth": {
    "inactivityTimeout": 0,
    "inactivityWarning": 0
  },
  "statusApp": {
    "apiRootUrl": "https://@.demo.serveport.com/_api/maintenance/",
    "code": "4M5ANviM0RwUqsdw1DpfPg5ygi6luDkbARDd22N3x2OfAzFuWH3POw==",
    "cacheDurationInMinutes": 5
  },
  "featureFlags": {
    "demoPreviews": true,
    "devTools": false,
    "devExceptions": false
  },
  "loggers": {
    "elmah": {
      "apiKey": "752d3d5a800541cd8dd1b5d747cc188a",
      "logId": "b4d08d9d-31b1-46cb-ab06-3f5272c67f6a"
    },
    "appInsights": {
      "instrumentationKey": "8de08394-cda6-438e-9b7e-f15299ae59ff"
    }
  },
  "uiSettings": {
    "hasNavbar": true,
    "list": {
      "maxCountInMemory": 10000,
      "pageSize": 20
    },
    "maxSubtypesToShowInDropdown": 0,
    "updatePollFrequency": 3600,
    "richTextEditor": {
      "initializationTimeoutInMs": 2000
    },
    "file": {
      "tusUploadLimitInMb": 0,
      "maxCorrespondenceSizeAttachmentInMb": 25,
      "previewDialogTimeLimitInSeconds": 5,
      "downloadTarget": "_self"
    },
    "reports": {
      "key": "Z7EC-XGIC55-0N4F3F-1V0I54-5H0S6L-2A2S08-3C0O26-4D5X6H-41036E-4M3C3L"
    }
  },
  "signalR": {
    "hubs": [
      {
        "api": "rms",
        "name": "submissions",
        "url": "signalr/submissions"
      }
    ]
  }
}
